<template lang="pug">
    div.vibe
        div.vibe-status
            //- div.vibe-status__controller
            //-     span( v-if="gamepad" ) {{ gamepadType }} Controller detected
            //-     span( v-else ) Controller not detected
            //- div.vibe-status__rumble
            //-     span( v-if="rumble" ) Rumble on
            //-     span( v-else ) Rumble off
        div.vibe-options
            div.vibe-options__rumble( :class="{ 'vibe-options__rumble--active' : rumble }" )
            select.vibe-options__select( v-model="vibrationType" :disabled="gamepad ? false : 'disabled'" )
                option( v-for="(preset, name) in gamepadPresets" ) {{ name }}
                option( value="controlled" ) Gamepad Controlled
                //- option( value="manual" ) Manual Values
        div.vibe-controls( :class="{ 'vibe-controls--animate' : gamepad }" :style="{ 'background-image': 'url('+gamepadAsset+')' }" )
            div.vibe-controls__no-gamepad( v-if="!gamepad" ) 
                div.subtitle-1 No Controller Detected
                div.subtitle-2 Press a button on your controller to connect
            div( v-if="vibrationType == 'controlled'" )
                div
                    progress-bar( :value="controlled.weakMagnitude * 100" color="blue" )
                    progress-bar( :value="controlled.strongMagnitude * 100" color="red" )
            div( v-else-if="vibrationType == 'manual'")
                button.vibe-controls__add-group( @click="removeGroup" :disabled="vibrationGroups == vibrationGroupsMin" ) -
                button.vibe-controls__add-group( @click="addGroup" :disabled="vibrationGroups >= vibrationGroupsMax" ) +
                button.vibe-controls__reset( @click="resetGroups" ) Reset
                div.vibe-controls__group
                    vibe-control-panel( 
                        v-for="index in vibrationGroupsMax" 
                        :key="index" 
                        v-model="manual[ index - 1 ]"
                        :disabled="index > vibrationGroups" 
                    ) 
        div.body-copy( v-show="gamepad" ) Press X or A to start.
</template> 

<script>
    import { mapGetters } from 'vuex';

    import ProgressBar from '@/components/ProgressBar';
    import VibeControlPanel from '@/components/VibeControlPanel';

    export default {
        name: "Vibe",
        components: {
            ProgressBar,
            VibeControlPanel
        },
        data() {
            return {
                ready: false,
                rumble: false,
                controlled: {
                    duration: 300,
                    weakMagnitude: 1,
                    strongMagnitude: 1
                },
                manual: [{
                    duration: 300,
                    weakMagnitude: 1,
                    strongMagnitude: 1
                }],
                vibrationGroups: 1,
                vibrationGroupsMin: 1,
                vibrationGroupsMax: 8,
                vibrationGroupsIndex: 0,
                vibrationType: 'Constant Strong',
                buttons: [],
                startTime: 0,
                controlledTime: 0
            }
        },
        computed: {
            ...mapGetters([
                'gamepad',
                'gamepadType',
                'gamepadPresets'
            ]),
            gamepadAsset() {
                let type = this.gamepadType || 'none';
                return require('@/assets/controller-'+type+'.png');
            },
            vibrationOptions() {
                return {
                    startDelay: 0,
                    weakMagnitude: this.currentWeakMagnitude,
                    strongMagnitude: this.currentStrongMagnitude,
                    duration: this.currentDuration
                }
            },
            currentWeakMagnitude() {
                let value = this.vibrationType == 'controlled' ? parseFloat( this.controlled.weakMagnitude ) :
                            this.vibrationType == 'manual' ? parseFloat( this.manual[ this.vibrationGroupsIndex ].weakMagnitude ) :
                            this.gamepadPresets[ this.vibrationType ][ this.vibrationGroupsIndex ].weakMagnitude;
                return value;
            },
            currentStrongMagnitude() {
                let value = this.vibrationType == 'controlled' ? parseFloat( this.controlled.strongMagnitude ) :
                            this.vibrationType == 'manual' ? parseFloat( this.manual[ this.vibrationGroupsIndex ].strongMagnitude ) :
                            this.gamepadPresets[ this.vibrationType ][ this.vibrationGroupsIndex ].strongMagnitude;
                return value;
            },
            currentDuration() {
                let value = this.vibrationType == 'controlled' ? parseFloat( this.controlled.duration ) :
                            this.vibrationType == 'manual' ? parseFloat( this.manual[ this.vibrationGroupsIndex ].duration) :
                            this.gamepadPresets[ this.vibrationType ][ this.vibrationGroupsIndex ].duration;
                return value;
            }
        },
        watch: {
            gamepad() {
                let buttons = [];
                let pressed = null;
                let now = Date.now();

                if ( this.gamepad ) {
                    for (let index=0; index<this.gamepad.buttons.length; index++) {
                        buttons.push(this.gamepad.buttons[index].pressed);
                    }
                } else {
                    this.vibrateOff();
                    this.ready = false;
                }

                this.buttons = buttons;
            },
            vibrationType() {
                this.vibrationGroupsIndex = 0;
                if ( this.rumble ) {
                    this.vibrateOff();
                    this.vibrateOn();
                }
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                this.startButtons();
                this.controlledButtons();
            },

            addGroup() {
                this.vibrationGroups++;
            },
            removeGroup() {
                this.vibrationGroups--;
                if ( this.vibrationGroupsIndex >= this.vibrationGroups ) this.vibrationGroupsIndex = 0;
            },
            resetGroups() {
                this.vibrationGroups = 1;
                this.vibrationGroupsIndex = 0;

                if ( this.rumble ) {
                    this.vibrateOff();
                }
            },

            toggleRumble() {
                if ( !this.rumble ) {
                    this.vibrateOn();
                } else {
                    this.vibrateOff();
                }
            },

            vibrateOn() {
                clearTimeout( this.rumble );
                this.rumble = setTimeout( () => { 
                    this.vibrateOn(); 
                }, this.currentDuration - 4 ); 
                this.vibrate();
            },
            vibrateOff() {
                clearTimeout( this.rumble );
                this.rumble = false;
                this.vibrate( 0 );
            },
            vibrate( duration ) {
                if ( this.gamepad ) {
                    let options = duration != null ? Object.assign({}, this.vibrationOptions, { duration: duration }) : this.vibrationOptions;
                    this.gamepad.vibrationActuator.playEffect("dual-rumble", options);
                    
                    let date = new Date();
                    console.log( date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds() + '.' + date.getMilliseconds() );

                    if ( duration == null ) {
                        this.vibrationGroupsIndex++;
                        let max = this.gamepadPresets[ this.vibrationType ] ? this.gamepadPresets[ this.vibrationType ].length : this.vibrationGroups;
                        if ( this.vibrationGroupsIndex == max ) this.vibrationGroupsIndex = 0;
                    }
                }
            },
            startButtons() {
                let pressed = this.buttons[0] || this.buttons[1] || this.buttons[2] || this.buttons[3];

                if ( !this.ready && this.gamepad && pressed === false ) this.ready = true;
                if ( pressed !== false && this.ready ) {
                    let now = Date.now();
                    if ( now > this.startTime + 200 ) {
                        this.startTime = now;
                        this.toggleRumble();
                    }
                }
                requestAnimationFrame( this.startButtons.bind(this) );
            },
            controlledButtons() {

                if ( this.vibrationType == 'controlled' ) {

                    let strong = this.controlled.strongMagnitude;
                    let weak = this.controlled.weakMagnitude;
                    let increment = 0.01;

                    let modifier = 0;

                    if ( this.buttons[12] ) strong = strong + increment;
                    if ( this.buttons[13] ) strong = strong - increment;
                    if ( this.buttons[14] ) weak = weak - increment;
                    if ( this.buttons[15] ) weak = weak + increment;

                    strong = strong < 1 && strong > 0 ? strong : Math.round(strong);
                    weak = weak < 1 && weak > 0 ? weak : Math.round(weak);

                    if ( strong != this.controlled.strongMagnitude ) this.$set( this.controlled, 'strongMagnitude', strong );
                    if ( weak != this.controlled.weakMagnitude ) this.$set( this.controlled, 'weakMagnitude', weak );

                }

                requestAnimationFrame( this.controlledButtons.bind(this) );
            }

        }
    };
</script>

<style scoped lang="scss">
    .vibe-options {
        position: relative;
        display: inline-block;
        vertical-align: middle;
        margin-bottom: 20px;
        padding: 10px 10px 10px 50px;
        border: 1px solid #ddd;
        border-radius: 100px;

        &--focus {
            border-color: blue;
        }

        &:before {
            content: '';
            position: absolute;
            width: 0;
            height: 0;
            top: 50%;
            right: 18px;
            margin-top: -3px;
            border-left: 6px solid transparent;
            border-right: 6px solid transparent;
            border-top: 6px solid #aaa;
        }

        &__rumble {
            position: absolute;
            display: inline-block;
            width: 15px;
            height: 15px;
            top: 50%;
            left: 25px;
            margin-right: 8px;
            border-radius: 100px;
            border: 3px solid #fae0dc;
            vertical-align: middle;
            background-color: red;
            transform: translate(-50%, -50%);

            transition: all 120ms linear;

            &--active {
                width: 22px;
                height: 22px;
                background-color: green;
                border-color: #d5f2ce;
                border-width: 6px;
            }

        }

        &__select {
            position: relative; 
            outline: none;
            padding-right: 36px;
            z-index: 2;

            &[disabled] {
                opacity: 0.4;
            }
        }
    }

    .vibe-controls {
        position: relative;
        width: 100%;
        max-width: 800px;
        min-height: 482px;
        margin: 0 auto;

        background-size: contain;
        background-repeat: no-repeat;
        background-position: center center;

        opacity: 0.5;

        > * {
            position: relative;
            z-index: 1;
        }

        &:before {
            content: '';
            position: absolute;
            display: none;
            width: 100%;
            height: 100%;
            background-image: url('../assets/transition-mask-2.png');
            background-size: 2900% 100%;
            background-position: 100% 0;
            z-index: 0;
        }

        &--animate {
            opacity: 1;

            &:before {
                display: block;
                animation: takeover-mask-steps 1400ms steps(29, end) 1;
                animation-fill-mode: forwards;
                animation-direction: reverse;
            }
        }

        &__no-gamepad {
            position: absolute;
            top: 50%;
            left: 50%;
            padding: 20px 40px;
            text-align: center;
            background-color: rgba(#fff, 0.6);
            border: 1px solid #bbb;
            transform: translate(-50%, -50%);

            .subtitle-1 {
                color: #000;
                line-height: 1;
            }
            .subtitle-2 {
                color: #666;
            }
        }

        &__group {
            display: flex;
            flex-wrap: wrap;
        }
        &__group-item {
            position: relative;
            width: 200px;
            padding: 2rem 0.8rem 3rem;
            border: 2px solid #fff;
            border-radius: 20px;
            background-color: #ccc;
            box-sizing: border-box;
            overflow: hidden;

            transition: opacity 100ms ease-in-out;

            &--disabled {
                opacity: 0.5;
            }

            &:after {
                position: absolute;
                content: 'V';
            }

            // @media screen and (max-width: 800px) {
            //     width: 33%;
            // }
        }
        &__group-label {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            padding: 0.4rem 0;
            background-color: #aaa;
        }

        &__label {
            font-size: 0.7rem;
            font-weight: bold;
        }
    }

    @keyframes takeover-mask-steps {
        from { background-position: 0% center; }
        to { background-position: 100% center; }
    }
    @keyframes takeover-mask-steps-backwards {
        from { background-position: 100% center; }
        to { background-position: 0% center; }
    }
</style>
